import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { TextSkeleton as i } from "../../../../components/TextSkeleton/index.js";
import { ContainerSkeleton as S, ImageSkeleton as k, Content as d, TitleSkeletonContainer as c, HeaderSkeleton as m, StoreSkeleton as n, TimeStampSkeleton as l, TitleSkeleton as h, FooterSkeleton as a, StampSkeleton as p } from "../DealCard/style.js";
import { ActionsSkeleton as f, FollowSkeletonContainer as s, NotificationSkeleton as C, SaveSkeleton as x } from "./style.js";
const F = ({
  animate: t,
  className: r
}) => /* @__PURE__ */ o(S, { animate: t, className: r, children: [
  /* @__PURE__ */ e(k, {}),
  /* @__PURE__ */ o(d, { children: [
    /* @__PURE__ */ o(c, { children: [
      /* @__PURE__ */ o(m, { children: [
        /* @__PURE__ */ e(n, {}),
        /* @__PURE__ */ e(l, {})
      ] }),
      /* @__PURE__ */ o(h, { children: [
        /* @__PURE__ */ e(i, { width: "60%" }),
        /* @__PURE__ */ e(l, {})
      ] })
    ] }),
    /* @__PURE__ */ o(a, { children: [
      /* @__PURE__ */ e(p, {}),
      /* @__PURE__ */ e(n, {})
    ] })
  ] }),
  /* @__PURE__ */ e(f, { children: /* @__PURE__ */ o(s, { children: [
    /* @__PURE__ */ e(C, { animate: t }),
    /* @__PURE__ */ e(x, { animate: t })
  ] }) })
] });
export {
  F as DealSavedCardSkeleton
};
